import script from "./GodApeQuestMap.vue?vue&type=script&setup=true&lang=js"
export * from "./GodApeQuestMap.vue?vue&type=script&setup=true&lang=js"

import "./GodApeQuestMap.vue?vue&type=style&index=0&id=81a54ed6&lang=scss"

const __exports__ = script;

export default __exports__